import React from 'react';
import '../Style/privacyManager.css';

const GoalPrivacyManager = ({
  profile,
  onUpdateBio,
  goals,
  achievements = [],
  onTogglePrivacy,
  onToggleProfilePrivacy,
  onClose,
}) => {
  const [tempBio, setTempBio] = React.useState(profile?.bio || '');

  // Inside GoalPrivacyManager.js
  const handleBioSave = () => {
    console.log('🔍 Profile object:', profile); // ✅ add this
    console.log('🔍 Profile ID:', profile?.id);
    const profileId = profile?.id || profile?.userId;

    if (profileId) {
      onUpdateBio(profileId, tempBio);
    } else {
      console.error('Cannot save: Profile ID is missing. Profile:', profile);
    }
  };

  return (
    <div className="privacy-modal-overlay" onClick={onClose}>
      <div className="privacy-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-modal-header">
          <div className="header-title-group">
            <h2>Privacy Control Center</h2>
            <p className="header-subtitle">Manage visibility for your public profile</p>
          </div>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* ✅ Profile Privacy Section */}
        <h3
          className="privacy-section-title"
          style={{
            padding: '0 24px',
            fontSize: '0.9rem',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          🔒 Profile Privacy
        </h3>

        <div className="privacy-item-card" style={{ margin: '8px 16px 24px' }}>
          <div className="goal-info">
            <span className="goal-title">Private Profile</span>
            <span className="goal-meta-tag">{profile?.isPrivate ? 'Private' : 'Public'}</span>
          </div>
          <div className="toggle-section">
            <div className="toggle-group">
              <div className="toggle-label-area">
                <span className="icon">🔒</span>
                <span>Hide from everyone</span>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={!!profile?.isPrivate}
                  onChange={onToggleProfilePrivacy}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="privacy-list">
          {/* ✅ Bio Management Section */}
          <h3
            className="privacy-section-title"
            style={{
              padding: '0 24px',
              fontSize: '0.9rem',
              color: '#64748b',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            📝 Public Identity
          </h3>

          <div
            className="privacy-item-card bio-card-wrapper"
            style={{
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: '12px',
              margin: '8px 16px 24px',
            }}
          >
            <div
              className="bio-header"
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <span className="goal-title">Profile Bio</span>
              <span
                className={`char-count ${tempBio.length >= 150 ? 'limit' : ''}`}
                style={{ fontSize: '0.75rem', fontWeight: '600' }}
              >
                {tempBio.length} / 150
              </span>
            </div>

            <textarea
              className="privacy-bio-textarea"
              value={tempBio}
              onChange={(e) => setTempBio(e.target.value.slice(0, 150))}
              placeholder="Write a short tagline for your profile..."
            />

            <div className="bio-footer" style={{ justifyContent: 'flex-end' }}>
              {tempBio !== (profile?.bio || '') && (
                <button className="bio-save-mini-btn action-save-btn" onClick={handleBioSave}>
                  Update Bio
                </button>
              )}
            </div>
          </div>
          {/* ✅ Active Goals Section */}
          {goals.length > 0 && (
            <>
              <h3 className="privacy-section-title">🎯 Active Goals</h3>
              {goals.map((goal) => (
                <PrivacyItem key={goal.id} goal={goal} onTogglePrivacy={onTogglePrivacy} />
              ))}
            </>
          )}

          {/* ✅ Achievements Section */}
          {achievements.length > 0 && (
            <>
              <h3 className="privacy-section-title">🏆 Achievements</h3>
              {achievements.map((goal) => (
                <PrivacyItem key={goal.id} goal={goal} onTogglePrivacy={onTogglePrivacy} />
              ))}
            </>
          )}

          {goals.length === 0 && achievements.length === 0 && (
            <p style={{ textAlign: 'center', color: '#888', padding: '20px' }}>
              No goals or achievements yet.
            </p>
          )}
        </div>

        <div className="privacy-modal-footer">
          <button className="done-btn" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

// ✅ Extracted reusable item component
const PrivacyItem = ({ goal, onTogglePrivacy }) => (
  <div className="privacy-item-card">
    <div className="goal-info">
      <span className="goal-title">{goal.goalTitle || goal.title || 'Untitled'}</span>
      <span className="goal-meta-tag">{goal.category || 'General'}</span>
    </div>
    <div className="toggle-section">
      <div className="toggle-group">
        <div className="toggle-label-area">
          <span className="icon">👁️</span>
          <span>Hide Goal</span>
        </div>
        <label className="switch">
          <input
            type="checkbox"
            checked={!!goal.isPrivate}
            checked={!!(goal.isPrivate ?? goal.private)}
            onChange={() => onTogglePrivacy(goal.id, 'isPrivate', goal.isPrivate ?? goal.private)}
          />
          <span className="slider round"></span>
        </label>
      </div>
      <div className="toggle-group">
        <div className="toggle-label-area">
          <span className="icon">🔒</span>
          <span>Hide Notes</span>
        </div>
        <label className="switch">
          <input
            type="checkbox"
            checked={!!goal.notesPrivate}
            onChange={() => onTogglePrivacy(goal.id, 'notesPrivate', goal.notesPrivate)}
          />
          <span className="slider round"></span>
        </label>
      </div>
    </div>
  </div>
);

export default GoalPrivacyManager;
